<div class="d-flex flex-column min-vh-100">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <app-header></app-header>
    <app-banner></app-banner>
    <app-cookie-consent></app-cookie-consent>
</div>
